import React, { useRef, useState, useEffect } from 'react';
import NET from 'vanta/dist/vanta.net.min';

function Animation() {
    const animationRef = useRef(null);
    const [animationInstance, setAnimationInstance] = useState(null);

    useEffect(() => {
        if (animationRef && !animationInstance && window.THREE) {
            setAnimationInstance(
                NET({
                    el: animationRef.current,
                    THREE: window.THREE,
                    mouseControls: true,
                    touchControls: true,
                    gyroControls: false,
                    minHeight: 200.0,
                    minWidth: 200.0,
                    scale: 1,
                    scaleMobile: 1,
                    color: 0xf07f6d,
                    backgroundColor: 0x3b4a5d,
                    points: 8.0,
                    maxDistance: 28.0,
                    spacing: 24.0
                })
            );
        }

        return () => animationInstance && animationInstance.destroy();
    }, [animationRef, animationInstance, window.THREE]);

    return (
        <div
            style={{
                width: '120vw',
                height: '120vh',
                marginTop: '-10vh',
                marginLeft: '-10vw'
            }}
            ref={(refs) => {
                if (refs) {
                    animationRef.current = refs;
                }
            }}
        />
    );
}

export default Animation;

// import React, { useState, useEffect, useRef } from 'react';
// import BIRDS from 'vanta/dist/vanta.birds.min';
// // import * as THREE from 'three';

// export default function MyComponent() {
//     const [vantaEffect, setVantaEffect] = useState(0);
//     const vantaRef = useRef(null);

//     useEffect(() => {
//         if (!vantaEffect && window.THREE) {
//             setVantaEffect(
//                 BIRDS({
//                     el: vantaRef.current,
//                     THREE: window.THREE,
//                     mouseControls: true,
//                     touchControls: true,
//                     gyroControls: false,
//                     minHeight: 600.0,
//                     minWidth: 600.0,
//                     scale: 1.0,
//                     scaleMobile: 1.0,
//                     color1: '#ff0000',
//                     color2: '#00ff00'
//                 })
//             );
//         }
//         return () => {
//             if (vantaEffect) vantaEffect.destroy();
//         };
//     }, [vantaEffect, window.THREE]);
//     return (
//         <div ref={vantaRef}>
//             <p style={{ color: '#fff', paddingTop: '20px' }}>
//                 Animated website backgrounds in a few lines of code.
//             </p>
//         </div>
//     );
// }
